import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PreChatRoute } from '@leagueplatform/pre-chat';
import { chatInstance } from 'common/chat-instance';
import { setPendingInitialMessage } from 'common/pending-initial-message';

type LiveChatLocationState = {
  initialMessage?: string;
  dispatchId?: string;
} | null;

// Entry point for the `liveChatStart` Masonry action (e.g. the "Ask Iris"
// hero) and any other in-app link into chat. Stashes an initial message
// carried in router state for the persistently-mounted chat container to
// auto-send once the session is ready (see `useAutoSendInitialMessage`),
// then hands off to the SDK's pre-chat flow.
export const LiveChatPage = () => {
  const location = useLocation();
  const locationState = location.state as LiveChatLocationState;
  const initialMessage = locationState?.initialMessage;
  const dispatchId = locationState?.dispatchId;

  useEffect(() => {
    setPendingInitialMessage(initialMessage, dispatchId);
  }, [initialMessage, dispatchId]);

  return <PreChatRoute chatInstance={chatInstance} />;
};
